import React from 'react'
import PageHeader from "../../components/PageHeader";
import { Box, TextField, Button } from "@mui/material";
function SmsServicePage() {
  return (
    <Box sx={{ display: "flex" }}>
    <Box
      sx={{
        flexGrow: 1,
        marginTop: 0,
        marginLeft: 15,
        marginRight: 15,
        marginBottom: 15,
      }}
    >
      <PageHeader pageTitle="Sms Service" />
      <div
        className="container"
        style={{
          // width: "300px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <div>
          <TextField
            type="password"
            label="API Key"
            name="api_key"
            // value={apiKey}
            variant="standard"
            // onChange={handleApiKeyChange}
            fullWidth
          />
        </div>
        <div>
          <TextField
            type="password"
            label="API Secret"
            name="api_secret"
            // value={apiSecret}
            variant="standard"
            // onChange={handleApiSecretChange}
            fullWidth
          />
        </div>
        </div>
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
          <Button  variant="contained" style={{backgroundColor:"#17202A" }}>Update</Button>
        </Box>
        
    </Box>
  </Box>
  )
}

export default SmsServicePage
